import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useNexauraData } from "../context/NexauraContext";
import { useToast } from "../components/common/ToastContext";
import Button from "../components/common/Button";
import { fmtUsdt } from "../utils/format";
import { DEFAULT_REFERRER } from "../config/contract";
import { LOGO_MARK } from "../config/assets";

function readRefFromUrl() {
  try {
    const params = new URLSearchParams(window.location.search);
    const r = params.get("ref");
    if (r && /^\d+$/.test(r)) return r;
  } catch {}
  return "";
}

const BENEFITS = [
  { ico: "🎯", label: "10% Direct referral income" },
  { ico: "⬆", label: "40% Upgrade income with auto-upgrade" },
  { ico: "⛓", label: "1.5% × 20 generation levels" },
  { ico: "👑", label: "Royalty + Gold/Diamond/Global clubs" },
  { ico: "⚡", label: "5x earning ceiling per board" },
];

export default function Register() {
  const { data, register, busy } = useNexauraData();
  const toast = useToast();
  const navigate = useNavigate();
  const [ref, setRef] = useState("");
  const [done, setDone] = useState(false);

  useEffect(() => {
    const r = readRefFromUrl();
    if (r) setRef(r);
  }, []);

  const price = data.prices[0];
  const bal = data.usdtBalance;
  const enough = bal && price ? bal.gte(price) : true;

  const handleRegister = async () => {
    const refId = ref && /^\d+$/.test(ref) ? ref : DEFAULT_REFERRER;
    const ok = await register(refId);
    if (ok) setDone(true);
  };

  // ── SUCCESS SCREEN ──
  if (done) {
    return (
      <div className="screen no-nav register">
        <div className="ambient"><i /><i /><i /></div>
        <div className="reg-success">
          <div className="rs-check"><span>✓</span></div>
          <h2 className="rs-title gradient-text">Welcome to Nexaura!</h2>
          <p className="rs-sub">Your account is live and Board 1 is activated.</p>
          {data.userId ? <div className="rs-id">Your ID: <b>#{data.userId}</b></div> : null}
          <Button onClick={() => navigate("/dashboard")}>Enter Dashboard</Button>
        </div>
      </div>
    );
  }

  return (
    <div className="screen no-nav register">
      <div className="ambient"><i /><i /><i /></div>

      <div className="reg-hero">
        <div className="reg-hero-glow" />
        <img src={LOGO_MARK} alt="Nexaura" className="reg-mark" />
        <div className="reg-welcome">Welcome to Nexaura</div>
        <div className="reg-sub">Activate Board 1 to start earning</div>
        <div className="reg-price">
          {price ? fmtUsdt(price) : "5"} <span>USDT</span>
        </div>
        <div className="reg-price-cap">one-time activation</div>
      </div>

      <div className="reg-benefits">
        {BENEFITS.map((b, i) => (
          <div className="reg-benefit" key={i} style={{ animationDelay: `${0.05 + i * 0.06}s` }}>
            <span className="rb-ico">{b.ico}</span>
            <span className="rb-text">{b.label}</span>
          </div>
        ))}
      </div>

      <div className="card reg-form">
        <div className="field" style={{ marginBottom: 6 }}>
          <label>Sponsor ID (optional)</label>
          <input
            inputMode="numeric"
            placeholder="Enter referrer ID"
            value={ref}
            onChange={(e) => setRef(e.target.value.replace(/[^\d]/g, ""))}
          />
        </div>
        <div className="reg-bal">
          <span className="muted">Your USDT balance</span>
          <span className={enough ? "" : "low"}>{bal ? fmtUsdt(bal) : "0"} USDT</span>
        </div>
      </div>

      {!enough && (
        <div className="reg-warn">⚠ You need at least {price ? fmtUsdt(price) : "5"} USDT (plus a little BNB for gas).</div>
      )}

      <Button loading={busy} disabled={!enough} onClick={handleRegister}>
        {busy ? "Processing…" : "Register & Activate Board 1"}
      </Button>
      <div className="reg-foot muted">You'll approve USDT, then confirm registration in your wallet.</div>

      {data.isAdmin && (
        <div style={{ marginTop: 12 }}>
          <Button variant="secondary" onClick={() => navigate("/admin")}>Open Admin Panel</Button>
        </div>
      )}
    </div>
  );
}
